import React, { useState, useEffect } from 'react';
import { FaWhatsapp, FaGlobe, FaFacebookMessenger } from 'react-icons/fa';

// ===================================================================================
// A. Helper Components (Kept as is, they work perfectly)
// ===================================================================================
const ChannelIcon = ({ channel }) => {
    const commonClass = "text-slate-400";
    switch (channel) {
        case 'whatsapp': return <FaWhatsapp className={commonClass} />;
        case 'messenger': return <FaFacebookMessenger className={commonClass} />;
        case 'web':
        default: return <FaGlobe className={commonClass} />;
    }
};

const useWaitTimer = (timestamp) => {
    const [waitTime, setWaitTime] = useState('0s');
    useEffect(() => {
        const calculateTime = () => {
            const seconds = Math.floor((Date.now() - new Date(timestamp).getTime()) / 1000);
            if (seconds < 60) return `${seconds}s`;
            const minutes = Math.floor(seconds / 60);
            return `${minutes}m`;
        };
        const interval = setInterval(() => setWaitTime(calculateTime()), 1000);
        setWaitTime(calculateTime()); // Initial calculation
        return () => clearInterval(interval);
    }, [timestamp]);
    return waitTime;
};

// ===================================================================================
// B. The Final, Redesigned Request Card
// ===================================================================================
export function RequestCard({ request, onAccept }) {
    const waitTime = useWaitTimer(request.timestamp);

    // The entire card is a single clickable entity to accept the chat.
    return (
        <div 
            className="bg-gray-800/50 border border-gray-700 rounded-lg p-3 transition-colors duration-200 hover:bg-gray-700/60 cursor-pointer" 
            onClick={() => onAccept(request)}
        >
            <div className="flex justify-between items-center mb-2">
                <div className="flex items-center gap-3 overflow-hidden">
                    <ChannelIcon channel={request.channel} />
                    <span className="font-semibold text-white text-sm truncate">User: ...{request.userId.slice(-12)}</span>
                </div>
                <span className="text-xs font-mono bg-slate-700 text-slate-300 px-2 py-0.5 rounded-full flex-shrink-0">
                    {waitTime}
                </span>
            </div>
            
            <p className="text-slate-400 text-sm mb-3 truncate">
                {request.message}
            </p>

            <button
                className="w-full bg-cyan-600 text-white font-semibold py-2 rounded-lg hover:bg-cyan-700 transition-colors text-sm"
                aria-label={`Accept chat from user ${request.userId}`}
            >
                Accept Chat
            </button>
        </div>
    );
}